import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageContainer } from '@app/layout/page-container/page-container';
import { Button } from '@app/shared/ui/button/button';
import { AuthService } from '@app/core/auth/auth.service';
import { ApiError } from '@app/core/api/api.model';

@Component({
  imports: [PageContainer, ReactiveFormsModule, RouterLink, TranslocoDirective, Button],
  selector: 'app-login',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './login.css',
  templateUrl: './login.html',
})
export class Login {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly router = inject(Router);
  protected readonly auth = inject(AuthService);

  protected readonly form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  protected readonly error = signal<string | null>(null);

  protected submit(): void {
    if (this.form.invalid || this.auth.loading()) {
      this.form.markAllAsTouched();
      return;
    }

    this.error.set(null);
    this.auth.login(this.form.getRawValue()).subscribe({
      next: () => void this.router.navigateByUrl('/'),
      error: (err) => {
        this.error.set(
          err instanceof ApiError ? err.message : 'Something went wrong. Try again.',
        );
      },
    });
  }
}
